import { getEnv } from './environment'

export const accountCreationUrlEnv = () => {
  const env = getEnv()

  if (env === 'prod') return ''
  else if (env === 'uat') return 'preprod.'
  else return 'test.'
}
